// extracted by mini-css-extract-plugin
module.exports = {"text":"Icons_text__HOyk8","item":"Icons_item__W043c","button":"Icons_button__r6kuo","link":"Icons_link__crx1C","icon":"Icons_icon___GFz0"};